import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LANGUAGES } from '@lib/core/const';
import { SmtpStatus } from '@lib/core/model';
import { ConfigurableDialog, DialogModule, DialogService } from '@proget-shared/dialog';
import { DropdownItem, DropdownModule } from '@proget-shared/form/dropdown';
import { FormControlErrorModule } from '@proget-shared/form/form-control-error';
import { FormControlLabelModule } from '@proget-shared/form/form-control-label';
import { TranslateModule } from '@proget-shared/translate';
import { TooltipModule } from '@proget-shared/ui/tooltip';

@Component({
  selector: 'lib-reset-password',
  imports: [
    ReactiveFormsModule,
    DialogModule,
    DropdownModule,
    FormControlErrorModule,
    FormControlLabelModule,
    TranslateModule,
    TooltipModule,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements ConfigurableDialog {
  protected readonly form: FormGroup = null;
  protected readonly languageOptions: DropdownItem[] = [
    { label: 'common.do_not_send', value: null },
    ...LANGUAGES.map((lang) => ({ label: `language_dropdown.options.${lang}`, value: lang })),
  ];

  protected smtpStatus: SmtpStatus | null;

  private readonly dialogService = inject(DialogService);

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group({
      emailLanguage: [null],
    });
  }

  onConfiguration({ smtpStatus }: { smtpStatus: SmtpStatus }): void {
    this.smtpStatus = smtpStatus;

    if (!this.smtpStatus.active) {
      this.form.get('emailLanguage').disable();
    }
  }

  protected close(): void {
    this.dialogService.reject(this);
  }

  protected submit({ value }: FormGroup): void {
    this.dialogService.resolve(this, value.emailLanguage);
  }
}
